import React, { memo } from 'react';
import PropTypes from 'prop-types';
import animateLoader from 'desktop/utils/animateLoader';
import {
  ButtonStyled,
  ContentWrap,
  StyledIcon,
  StyledText,
  Loader,
  LoaderCircle,
} from './styles/ButtonStyled';

const Button = ({
  icon,
  type,
  active,
  text,
  spacing,
  textSize,
  textType,
  textFont,
  disable,
  isLoading,
  size,
  align,
  iconSize,
  iconColor,
  background,
  buttonStyle,
  isMobile,
  textColor,
  hoverColor,
  fixedTextSize,
  separation,
  tag,
  onClick,
  className,
}) => {
  const getSvgRef = (ref) => {
    animateLoader(ref, 1, 0, 1, 'button', isLoading);
  };

  return (
    <ButtonStyled
      className={className}
      onClick={onClick}
      as={tag}
      size={size}
      active={active}
      disable={disable}
      buttonStyle={buttonStyle}
      type={type}
      style={{
        backgroundColor: background,
      }}
    >
      <ContentWrap align={align}>
        {isLoading && (
          <Loader viewBox="25 25 50 50">
            <LoaderCircle ref={getSvgRef} cx="50" cy="50" r="20" fill="none" />
          </Loader>
        )}
        {icon && !isLoading && (
          <StyledIcon
            buttonStyle={buttonStyle}
            isMobile={isMobile}
            disable={disable}
            name={icon}
            color={textColor || iconColor}
            hoverColor={hoverColor}
            size={iconSize}
            separation={separation}
          />
        )}
        {text && !isLoading && (
          <StyledText
            tag="span"
            buttonStyle={buttonStyle}
            isMobile={isMobile}
            disable={disable}
            color={textColor}
            hoverColor={hoverColor}
            fixedSize={fixedTextSize}
            size={textSize}
            type={textType}
            font={textFont}
            spacing={spacing}
          >
            {text}
          </StyledText>
        )}
      </ContentWrap>
    </ButtonStyled>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  tag: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  type: PropTypes.string,
  active: PropTypes.bool,
  textColor: PropTypes.string,
  textSize: PropTypes.string,
  textType: PropTypes.string,
  textFont: PropTypes.string,
  hoverColor: PropTypes.string,
  size: PropTypes.string,
  disable: PropTypes.bool,
  align: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  background: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonStyle: PropTypes.string,
  isMobile: PropTypes.bool,
  fixedTextSize: PropTypes.bool,
  separation: PropTypes.number,
  spacing: PropTypes.number,
  className: PropTypes.string,
};

Button.defaultProps = {
  onClick: Function.prototype,
  tag: 'button',
  icon: null,
  text: null,
  type: null,
  active: false,
  textColor: null,
  textSize: null,
  textType: null,
  textFont: null,
  hoverColor: null,
  size: null,
  disable: false,
  align: null,
  iconSize: 24,
  iconColor: 'white',
  background: null,
  isLoading: false,
  buttonStyle: null,
  isMobile: false,
  fixedTextSize: false,
  separation: null,
  spacing: null,
  className: '',
};

export default memo(Button);
